export default {"src":"/_next/static/media/whiskey-barrel.fb2ad07a.svg","height":152,"width":150,"blurWidth":0,"blurHeight":0};